/* eslint-disable react/no-danger */

// Modules
import React, { useContext } from 'react';
import ReactGA from 'react-ga4';
import { createMarkup } from 'utilities/utils';

import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

// Utils:
import TopicConfigContext from 'utilities/topicConfigContext';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box className="MuiTypography-body1" p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function About() {
    // // State // //
    const [value, setValue] = React.useState(0);

    // // Context // //
    const {
        theme: { about, resources },
    } = useContext(TopicConfigContext);

    // // Methods // //
    const handleChange = (event, newValue) => {
        setValue(newValue);

        // Record Google Analytics event for tab change
        const action =
            newValue === 0
                ? 'Click back to About tab'
                : 'Click to Resources tab';
        ReactGA.event({
            category: 'Navigation',
            action,
            label: window.location.pathname + window.location.search,
        });
    };

    // // Render // //
    return (
        <div className="about-main-container">
            <Paper>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="More Information"
                >
                    {about ? <Tab label="About" {...a11yProps(0)} /> : null}
                    {resources ? (
                        <Tab label="Resources" {...a11yProps(1)} />
                    ) : null}
                </Tabs>
            </Paper>
            {about.length ? (
                <TabPanel value={value} index={0}>
                    <div dangerouslySetInnerHTML={createMarkup(about)} />
                </TabPanel>
            ) : null}
            {resources.length ? (
                <TabPanel value={value} index={1}>
                    <div dangerouslySetInnerHTML={createMarkup(resources)} />
                </TabPanel>
            ) : null}
        </div>
    );
}
